import { GroupType } from '../typings/domain';
import { GroupId } from '../typings/groups';

export const OPEN_PLATFORMS_PREVIEW = 'OPEN_PLATFORMS_PREVIEW';
export type OPEN_PLATFORMS_PREVIEW = typeof OPEN_PLATFORMS_PREVIEW;

export interface OpenPlatformsPreview {
    type: OPEN_PLATFORMS_PREVIEW;
    groupId: GroupId;
    previewType: GroupType;
}

export function openPlatformsPreview(
    groupId: GroupId,
    previewType: GroupType
): OpenPlatformsPreview {
    return {
        type: OPEN_PLATFORMS_PREVIEW,
        groupId,
        previewType
    };
}

export const CLOSE_PLATFORMS_PREVIEW = 'CLOSE_PLATFORMS_PREVIEW';
export type CLOSE_PLATFORMS_PREVIEW = typeof CLOSE_PLATFORMS_PREVIEW;

export interface ClosePlatformsPreview {
    type: CLOSE_PLATFORMS_PREVIEW;
    groupId: GroupId;
}

export function closePlatformsPreview(groupId: GroupId): ClosePlatformsPreview {
    return {
        type: CLOSE_PLATFORMS_PREVIEW,
        groupId
    };
}

export type OpenPlatformsPreviewAction =
    | OpenPlatformsPreview
    | ClosePlatformsPreview;
